import { CallbackElement } from '@swagger-api/apidom-ns-openapi-3-0';
class Callback extends CallbackElement {}
export default Callback;